import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useFeatureFlags, FlagKey } from "../contexts/FeatureFlagsContext";

interface FeatureFlagGuardProps {
  flag: FlagKey;
  children: React.ReactNode;
}

const FeatureFlagGuard: React.FC<FeatureFlagGuardProps> = ({
  flag,
  children,
}) => {
  const { hasFlag, isLoading } = useFeatureFlags();

  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!hasFlag(flag)) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Funcionalidade Indisponível
        </Typography>
        <Typography variant="body1" color="text.secondary" maxWidth={420}>
          Esta funcionalidade está desabilitada pelo administrador da
          plataforma. Entre em contato com o suporte se acreditar que isto é um
          erro.
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default FeatureFlagGuard;
